/**
 * SVG Elasticsearch icon
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const propTypes = {
  classes: PropTypes.shape({
    circleStyle: PropTypes.string.isRequired,
    searchStyle: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledElasticsearchIcon({ ...props }) {
  const { classes, ...additionalProps } = props;
  const { circleStyle, searchStyle } = classes;
  return (
    <SvgIcon viewBox="0 0 120 120" {...additionalProps}>
      <g>
        <circle className={circleStyle} cx="60" cy="60" r="55.5" />
        <path
          className={searchStyle}
          d="M77,41.3c-5.5-12.4-20-17.9-32.4-12.4c-12.4,5.5-17.9,20-12.4,32.4c5.5,12.4,20,17.9,32.4,12.4
          C77,68.1,82.5,53.6,77,41.3z M62.6,69.2c-9.9,4.4-21.5,0-25.9-9.9c-4.4-9.9,0-21.5,9.9-25.9c9.9-4.4,21.5,0,25.9,9.9
          C76.9,53.1,72.5,64.8,62.6,69.2z"
        />
        <path
          className={searchStyle}
          d="M60.4,76.2l6.2,20.9c0.9,3.2,5.4,4.3,9.6,2.4l0,0c4.2-1.9,6.3-5.9,4.6-8.7L69.4,72.2C68,73,66.6,73.8,65,74.5
          C63.5,75.2,61.9,75.8,60.4,76.2z"
        />
      </g>
    </SvgIcon>
  );
}

UnstyledElasticsearchIcon.propTypes = propTypes;

const styles = (theme) => ({
  circleStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.white,
    stroke: theme.customColors.teal,
    strokeWidth: 7,
  },
  searchStyle: {
    fill: theme.customColors.teal,
    stroke: theme.customColors.teal,
  },
});

export default withStyles(styles)(UnstyledElasticsearchIcon);
